import React, { useState, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, ItemSecond } from './styles';
import { NavItem } from '../NavItem';

import { Typography, SlideToggle, Box } from '@utex/ui-kit';
import {
  IconSideFeed,
  IconSideIdeas,
  IconSidePortfolio,
  IconSideBook,
  IconSidePassport,
  IconSideAccounts,
} from '../Icons';

export interface NavigationProps {
  onIdeasClick: () => void;
  onPortfolioClick: () => void;
  onIPOClick: () => void;
  onPreIPOClick: () => void;
  onAccountClick: () => void;
  passportLink: string;
  activeItem?: 'ideas' | 'portfolio' | 'howItWorks' | 'account' | 'feed' | 'passport';
}

export function Navigation(props: NavigationProps) {
  const { t, i18n } = useTranslation('sidenav');
  const {
    onIdeasClick,
    onPortfolioClick,
    onIPOClick,
    onPreIPOClick,
    onAccountClick,
    passportLink,
    activeItem,
  } = props;
  const [isExpandMenusVisible, setIsExpandMenusVisible] = useState(false);

  return (
    <>
      <Container>
        {i18n.language === 'ru' && (
          <Box display={{ tablesktop: 'none' }}>
            <NavItem
              href="/feed"
              isActive={activeItem === 'feed'}
              icon={<IconSideFeed />}
              data-testid="feed-link"
            >
              <Typography.Text>{t('sidenav:Feed')}</Typography.Text>
            </NavItem>
          </Box>
        )}

        <NavItem
          href="/investments"
          isActive={activeItem === 'ideas'}
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onIdeasClick();
          }}
          icon={<IconSideIdeas />}
          data-testid="ideas-link"
        >
          <Typography.Text>{t('sidenav:Invest Ideas')}</Typography.Text>
        </NavItem>

        <NavItem
          href="/investments/open-investment"
          isActive={activeItem === 'portfolio'}
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onPortfolioClick();
          }}
          icon={<IconSidePortfolio />}
          data-testid="portfolio-link"
        >
          <Typography.Text>{t('sidenav:Portfolio')}</Typography.Text>
        </NavItem>

        <NavItem
          as="button"
          icon={<IconSideBook />}
          isActive={activeItem === 'howItWorks'}
          isExpand={true}
          isOpen={isExpandMenusVisible}
          onClick={(e: React.SyntheticEvent) => {
            e.preventDefault();
            setIsExpandMenusVisible(!isExpandMenusVisible);
          }}
          data-testid="howItWorks-link"
        >
          <Typography.Text>{t('sidenav:How It Works')}</Typography.Text>
        </NavItem>

        <SlideToggle isVisible={isExpandMenusVisible} duration={300}>
          <div id="menu-how-it-works" data-testid="menu-how-it-works">
            <ItemSecond isDisabled={true} data-testid="about-platform-link">
              {t('sidenav:About UT Platform')}
            </ItemSecond>

            <ItemSecond
              href="/how-it-works/ipo"
              onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                onIPOClick();
              }}
              data-testid="ipo-link"
            >
              {t('sidenav:IPO')}
            </ItemSecond>

            <ItemSecond
              href="/how-it-works/pre-ipo/what-is-pre-ipo"
              onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                onPreIPOClick();
              }}
              data-testid="pre-ipo-link"
            >
              {t('sidenav:Pre-IPO')}
            </ItemSecond>

            <ItemSecond isDisabled={true} data-testid="otc-link">
              {t('sidenav:OTC')}
            </ItemSecond>

            <ItemSecond isDisabled={true} data-testid="stocks-link">
              {t('sidenav:Stocks and ETF')}
            </ItemSecond>
          </div>
        </SlideToggle>

        <Box display={{ phonablet: 'none' }}>
          <NavItem
            href="/investments/open-investment"
            isActive={activeItem === 'account'}
            onClick={(e: SyntheticEvent) => {
              e.preventDefault();
              onAccountClick();
            }}
            icon={<IconSideAccounts />}
            data-testid="account-link"
          >
            <Typography.Text>{t('sidenav:My Accounts')}</Typography.Text>
          </NavItem>
        </Box>

        <Box display={{ phonablet: 'none' }}>
          <NavItem
            href={passportLink}
            isActive={activeItem === 'passport'}
            icon={<IconSidePassport />}
            target="_blank"
            data-testid="passport-link"
          >
            <Typography.Text as="div">{t('sidenav:UT Passport')}</Typography.Text>

            <Typography.Text as="div" view="hint" size="XS">
              {t('sidenav:Profile, Security, KYC')}
            </Typography.Text>
          </NavItem>
        </Box>
      </Container>
    </>
  );
}
